import { render, staticRenderFns } from "./ListaDistribucion.vue?vue&type=template&id=1d242a03&"
import script from "./ListaDistribucion.vue?vue&type=script&lang=ts&"
export * from "./ListaDistribucion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports